<template>
  <v-card outlined>
    <v-card-title class="py-1">
      审批历史
      <v-spacer></v-spacer>
      <!-- 船端不显示，船员无船舶分管数据，直接根据角色判断 -->
      <span class="text-h20" v-if="shipCode && !isShipSyS">
        当前审批人:{{ approvedManagersList }}
      </span>
      <!-- 待审批人 -->
      <v-btn
        text
        :loading="loading"
        v-if="!img && !isShip"
        color="primary"
        @click="loadPic"
        class="d-print-none"
      >
        显示流程图
      </v-btn>
      <v-btn
        text
        v-else-if="!!img && !isShip"
        color="primary"
        @click="img = null"
      >
        隐藏流程图
      </v-btn>
      <v-btn
        text
        :loading="loading"
        v-if="!showHistoryFlag"
        color="primary"
        @click="showHistoryFlag = true"
        class="d-print-none"
      >
        显示审批历史
      </v-btn>
      <v-btn
        text
        v-else-if="showHistoryFlag"
        color="primary"
        @click="showHistoryFlag = false"
      >
        隐藏审批历史
      </v-btn>
    </v-card-title>
    <v-card-text class="pb-0">
      <v-img
        v-if="img"
        @click="dialog = true"
        max-height="500"
        max-width="1000"
        :src="img"
      ></v-img>
      <v-divider></v-divider>
      <v-data-table
        v-if="showHistoryFlag"
        :headers="hisTaskHeaders"
        :items="hisTask"
        hide-default-footer
        disable-pagination
        dense
        class="use-divider"
      >
        <template v-slot:[`item.status`]="{ item }">
          {{ statusMap[item.status] || '' }}
        </template>
      </v-data-table>
      <v-divider></v-divider>
    </v-card-text>
    <v-card-text
      v-if="auditParams.taskId && !auditParams.isReject && isRoleManagerNew"
      class="py-0"
    >
      <v-radio-group
        :rules="[rules.radio]"
        ref="radio"
        class="pb-0"
        v-model="adopt"
        row
      >
        审批意见：
        <v-radio label="同意" :value="true"></v-radio>
        <v-radio label="退回" :value="false"></v-radio>
      </v-radio-group>
      <v-textarea
        class="mt-1"
        ref="textarea"
        label="批注"
        outlined
        height="80"
        :rules="adopt ? [] : [rules.required]"
        v-model="comment"
      ></v-textarea>
    </v-card-text>
    <v-dialog v-model="dialog" max-width="80%" max-height="80%">
      <v-img :src="img" contain></v-img>
    </v-dialog>
  </v-card>
</template>
<script>
export default {
  name: 'v-audit',
  props: {
    auditParams: {
      type: Object,
      default: () => ({
        taskId: '',
        processInstanceId: '',
      }),
    },
    showForm: {
      type: Boolean,
      default: true,
    },
    shipCode: {
      type: String,
      default: '',
    },
  },
  inject: {
    form: { default: null },
  },
  data() {
    return {
      showHistoryFlag: false,
      dialog: false,
      img: null,
      adopt: '',
      hisTask: [],
      comment: '',
      loading: false,
      rules: {
        radio: (v) => v !== '' || '请选择审批意见',
        required: (v) => !!v || '请输入批注',
      },
      approvedManagersList: '',
      isRoleManagerNew: true,
      isShipSyS: this.$local.data.get('userInfo').isShipSyS,
    }
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.$nextTick(() => {
          this.$refs.image.$el.querySelector('img').style.maxHeight = null
        })
      }
    },
    img(val) {
      if (val)
        this.$nextTick(() => {
          this.$refs.image.$el.querySelector('img').style.maxHeight = '100%'
        })
    },
  },

  methods: {
    async loadPerson() {
      if (this.auditParams.processInstanceId) {
        const manager = await this.getAsync(
          // '/business/common/ship/managementOwner/page',
          '/business/common/ship/managementOwner/pageNew',
          { size: 100, shipCode: this.shipCode },
        )
        console.log('船舶分管人员：', manager.data.records)
        console.log('审批数据：', this.auditParams)
        const approved = await this.getAsync(
          '/flow/task/getPersonByTaskIdAndShipCode',
          {
            taskId: this.auditParams.processInstanceId,
            shipCode: this.shipCode,
          },
        )
        console.log('可审批人员：', approved.data)
        // 归一化可审批人员姓名列表，去除空格、大小写差异，并去重
        const approvedNamesRaw = Array.isArray(approved.data)
          ? approved.data
          : []
        const approvedNames = approvedNamesRaw
          .map((n) => (typeof n === 'string' ? n.trim() : ''))
          .filter((n) => !!n)
        const approvedSet = new Set(approvedNames.map((n) => n.toLowerCase()))
        const uniqueManagers = new Set()

        // 遍历manager.data.records数组，并检查每个managerName是否存在于approvedNames中
        if (
          Array.isArray(approvedNames) &&
          manager &&
          manager.data &&
          manager.data.records &&
          Array.isArray(manager.data.records)
        ) {
          manager.data.records.forEach((record) => {
            const name =
              record && record.managerName ? record.managerName.trim() : ''
            if (!name) return
            if (approvedSet.has(name.toLowerCase())) {
              if (!uniqueManagers.has(name)) {
                uniqueManagers.add(name)
              }
            }
          })
        } else {
          console.log('Data is not valid or records are not available')
        }

        // 如果有已批准的managerName，将它们转换为一个逗号分隔的字符串并打印出来
        const approvedManagers = Array.from(uniqueManagers)
        this.approvedManagersList =
          approvedManagers.length > 0 ? approvedManagers.join(', ') : '无'
      } else {
        this.approvedManagersList = '无'
      }

      // 校验是否最新分配的一个船舶分管主管
      if (
        this.approvedManagersList.includes(
          this.$local.data.get('userInfo').nickName,
        ) ||
        this.$local.data.get('userInfo').roleName == '管理员'
      ) {
        this.isRoleManagerNew = true
      } else {
        this.isRoleManagerNew = false
      }
    },
    async loadHisTask() {
      const { data } = await this.getAsync(
        '/flow/task/getHisTaskInsListByProInsId',
        {
          processInstanceId: this.auditParams.processInstanceId,
        },
      )
      this.hisTask = data
    },
    arrayBufferToBase64(buffer) {
      let binary = ''
      let bytes = new Uint8Array(buffer)
      let len = bytes.byteLength
      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i])
      }
      return `data:image/bmp;base64,${window.btoa(binary)}`
    },
    async loadPic() {
      this.loading = true
      const result = await this.getArrayBuffer(
        '/flow/diagram/getTracePicByProcessInstanceId',
        { processInstanceId: this.auditParams.processInstanceId },
      )
      this.img = this.arrayBufferToBase64(result.data)
      this.loading = false
    },

    validate(force, value) {
      if (!this.$refs.radio) return true
      if (this.$refs.radio.validate(force, value)) {
        return this.$refs.textarea.validate(force, value)
      }
      return false
    },

    // 供外部调用
    async submit() {
      if (!this.auditParams.taskId) return null
      if (this.auditParams.isReject) this.adopt = true
      const { errorRaw } = await this.postAsync(
        '/flow/task/completeTaskAndCommentAndSetVar',
        {
          taskId: this.auditParams.taskId,
          comment: this.comment,
          adopt: this.adopt,
          params: {},
        },
      )
      return errorRaw
    },
  },

  created() {
    this.form && this.form.register(this)
    this.isShip = this.$local.data.get('userInfo').isShipSyS
    this.hisTaskHeaders = [
      { text: '环节名称', value: 'activityName' },
      { text: '任务状态', value: 'status' },
      { text: '审批人', value: 'assignee' },
      { text: '审批时间', value: 'endTime' },
      { text: '审批意见', value: 'comment' },
    ]
    this.statusMap = {
      success: '审批通过',
      reject: '审批驳回',
    }
  },
  beforeDestroy() {
    this.form && this.form.unregister(this)
  },
  mounted() {
    this.loadHisTask()
    if (this.shipCode && !this.isShipSyS) {
      this.loadPerson()
    }
  },
}
</script>

<style></style>
